import AppRouter from './AppRouter.js';
import AuthRouter from './AuthRouter.js';

export { AppRouter, AuthRouter };
